import { useAuth } from '../auth/AuthContext';
import { FREE_DAILY_LIMIT, PRO_DAILY_LIMIT } from '../util/constants';

export const useRemainingGenerations = (): number | null => {
    const { profile, profileLoading } = useAuth();
    if (profileLoading || !profile) return null;
    const today = new Date().toISOString().split('T')[0];
    const limit = profile.tier === 'pro' ? PRO_DAILY_LIMIT : FREE_DAILY_LIMIT;
    const used = profile.usage.lastResetDate === today ? profile.usage.generateCount : 0;
    return Math.max(0, limit - used);
};

export const useCanGenerate = (): boolean => {
    const remaining = useRemainingGenerations();
    return remaining !== null && remaining > 0;
};

export const useDailyLimit = (): number | null => {
    const { profile, profileLoading } = useAuth();
    if (profileLoading || !profile) return null;
    return profile.tier === 'pro' ? PRO_DAILY_LIMIT : FREE_DAILY_LIMIT;
};